module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly.3c21f1c4.svg";